import { Component, Prop, Mixins } from 'vue-property-decorator'
import KTable from '@kwixeo/table-vue/dist/components/Table/Table'
import { CustomFieldsTableMixin } from '@kwixeo/custom-fields-vue'
import uniq from 'lodash/uniq'
import { mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapGetters('subscriptions', ['hasModule'])
  }
})
export default class CatalogListMixin extends Mixins(CustomFieldsTableMixin) {
  hasModule!: (key: string) => boolean

  get rowActions (): KwixeoTable.RowActions {
    return []
  }

  @Prop({ default: false }) inlineMode!: boolean|undefined
  @Prop({ default: null }) addAction!: ((product: KwixeoCatalog.CatalogElement) => void)|null
  @Prop({ default: null }) defaultFilters!: KwixeoInterface.GenericObject|null
  @Prop({ default: () => [] }) relations!: string[]

  get include (): string[] {
    return []
  }

  get computedInclude (): string[] {
    return uniq([...this.include, ...this.relations])
  }

  get computedRowActions (): KwixeoTable.RowActions {
    const actions = this.rowActions

    const addAction = this.addAction
    if (addAction) {
      actions.unshift({
        icon: 'add',
        title: this.$t('interface.add') as string,
        click: (product: KwixeoCatalog.Product) => {
          addAction(product)
        }
      })
    }
    return actions
  }

  get actionsColumWidth (): number {
    return this.addAction ? 120 : 80
  }

  reload (): void {
    const table = this.$refs.table as KTable
    table.refresh()
  }
}
